<script lang="ts" setup>
defineOptions({
  name: 'OpenPageSection',
});
</script>

<template>
  <div class="open-page-section px-[20px] pb-[20px]">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
</style>
